<template>
  <div
    v-bind="$attrs"
    class="order-address-component d-flex align-center justify-space-between"
    :class="[{ checked }, currentComponentClass]"
    v-on="$listeners"
    @click="setAddress"
  >
    <div class="address-icon-section">
      <font-awesome-icon icon="home" />
    </div>
    <div class="address-info-section">
      <span class="address font-weight-bold">
        {{ getFullAddress }}
      </span>
      <!--      <span v-if="isAddressEqual" class="price-info">Доставка: {{ getDeliveryPrice }} {{ getFreeDeliveryPrice }}</span>-->
      <div class="address-info">
        <div>
          <div v-if="item.polygon" class="polygon-info">
            Филиал: {{ polygonInfoLabel }}, {{ polygonDeliveryTime }} от
            {{ polygonMinAmount | amountWithCurrency }}

            <work-time-label
              class="polygon-filial-work-time"
              :start-time="getFilialStartTime"
              :end-time="getFilialEndTime"
              :time-zone="getFilialTimeZone"
            />

            <span v-if="filialIsNotConnected" class="polygon-filial-alert">
              не подключен к FAKT
            </span>

            <filial-stop-label
              :filial-stop="polygonFilial.filialStop"
              variant="pill"
            />

            <v-tooltip
              v-if="polygonTooltipInfo"
              bottom
              close-delay="500"
              absolute
              open-on-click
              :attach="`.${currentComponentClass}`"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" class="polygon-info-icon" v-on="on">
                  <font-awesome-icon icon="info" />
                </span>
              </template>
              {{ polygonTooltipInfo }}
            </v-tooltip>
          </div>
          <div v-else class="polygon-error">
            <font-awesome-icon icon="exclamation-triangle" /> Адрес не входит в
            зону доставки!
            <span v-if="!hasGeo">Координаты не определены</span>
          </div>
        </div>

        <!--        <div class="geo-info">
          <a v-if="hasGeo" :href="mapLink" @click.stop="" target="_blank">
            <font-awesome-icon icon="map-marker-alt" />
            Посмотреть на карте</a>
        </div>-->
      </div>
    </div>
    <div class="buttons-section">
      <v-btn
        :class="[
          'action-button',
          'button-edit',
          { 'button-edit-white': checked },
          'mr-3',
        ]"
        icon
        depressed
        @click.stop="$emit('onEdit', item)"
      >
        <font-awesome-icon icon="edit" />
      </v-btn>
      <v-btn
        v-if="checked"
        class="action-button button-checked"
        icon
        depressed
        disabled
      >
        <font-awesome-icon icon="check" />
      </v-btn>
      <template v-else>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              class="action-button button-delete"
              icon
              depressed
              v-on="on"
              @click.stop="$emit('onDelete', item)"
            >
              <font-awesome-icon icon="trash" />
            </v-btn>
          </template>
          Удалить
        </v-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import PolygonType from '@/models/enums/PolygonType'
  import _ from 'lodash'
  import { secondsToHmsObject } from '@/util/date-time-helper'
  import WorkTimeLabel from '@/components/ui/WorkTimeLabel.vue'
  import FilialStopLabel from '@/components/stop-list/FilialStopLabel.vue'

  export default {
    name: 'Address',
    components: { WorkTimeLabel, FilialStopLabel },
    emits: ['onDelete'],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      isClickable: {
        type: Boolean,
        default: true,
      },
      checked: Boolean,
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      ...mapGetters({
        indicateFilialConnectionStatus: 'app/indicateFilialConnectionStatus',
      }),
      filialIsNotConnected () {
        return (
          this.indicateFilialConnectionStatus &&
        this.polygon?.filial?.isConnected === false
        )
      },
      getFilialStartTime () {
        return this.polygon?.filial?.startTime
      },
      getFilialEndTime () {
        return this.polygon?.filial?.endTime
      },
      getFilialTimeZone () {
        return this.polygon?.filial?.timeZone
      },
      currentComponentClass () {
        return `order-address-${this.item?.id}`
      },
      getFullAddress () {
        return this.item?.fullAddress
      },
      getCity () {
        return this.item.shortCity ? `${this.item.shortCity}, ` : ''
      },
      getHouse () {
        return this.item.house ? `, д. ${this.item.house}` : ''
      },
      getEntry () {
        return this.item.entry ? `, подъезд ${this.item.entry}` : ''
      },
      getFloor () {
        return this.item.floor ? `, ${this.item.floor} этаж` : ''
      },
      getApartment () {
        return this.item.apartmentNumber
          ? `, кв. ${this.item.apartmentNumber}`
          : ''
      },
      getFreeDeliveryPrice () {
        return this.basket && this.basket.freeDelivery
          ? `(бесплатно от ${this.basket.freeDelivery} ₽)`
          : ''
      },
      getDeliveryPrice () {
        return this.basket && this.basket.deliveryPrice
          ? this.basket.deliveryPrice + ' ₽'
          : '0 ₽'
      },
      isAddressEqual () {
        if (this.basket.clientAddress) {
          return this.basket.clientAddress.id === this.item.id
        }
        return false
      },

      polygon () {
        return this.item.polygon || {}
      },
      polygonFilial () {
        return this.polygon.filial || {}
      },
      polygonInfoLabel () {
        if (!_.isEmpty(this.polygon)) {
          const type = PolygonType.getName(this.polygon.type)
          return `${this.polygonFilial.name}, ${type} зона`
        }
        return ''
      },
      polygonDeliveryTime () {
        if (this.polygon?.time > 0) {
          return Math.floor(this.polygon?.time / 60) + ' минут,'
        }
        return null
      },
      polygonMinAmount () {
        return this.polygon?.freeFromPrice
      },
      polygonTooltipInfo () {
        return this.polygon?.name
      },
      hasGeo () {
        return !this.item.break_address && this.item.latGeo && this.item.letGeo
      },
      mapLink () {
        const filialId = this.item?.polygon?.filial?.id
        let link = `/geo/couriers-map?let=${this.item.letGeo}&lat=${this.item.latGeo}`
        if (filialId) {
          link += `&filialId=${this.polygonFilial.id}`
        }
        return link
      },
    },
    methods: {
      setAddress () {
        if (this.checked) {
          this.$emit('input', '')
        } else {
          this.$emit('input', this.item.id)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.order-address-component {
  margin-bottom: 15px;
  padding: 24px 25px 22px 21px;
  background-color: @color-secondary;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  .polygon-filial-work-time {
    display: inline-block;
    margin-left: 10px;
    margin-right: 5px;
  }

  .polygon-filial-alert {
    color: @color-pink;
    display: inline-block;
    padding: 1px 7px;
    font-size: 0.8rem;
    border: 1px solid @color-pink;
    border-radius: 100px;
    margin-left: 7px;
    position: relative;
    top: -2px;
  }

  .v-tooltip__content {
    background: #616161 !important;
    top: 85% !important;
    left: 0 !important;
  }

  .polygon-info-icon {
    margin-left: 7px;
    border: 1px solid;
    border-radius: 50%;
    //padding: 3px;
    width: 2em;
    height: 2em;
    line-height: 1.8em;
    display: inline-block;
    text-align: center;
    font-size: 9px;
    top: -2px;
    position: relative;
    cursor: pointer;
    vertical-align: middle;
  }

  .polygon-error {
    color: red;

    svg {
      margin-right: 10px;
      .fill-svg(red);
    }
  }

  .address-info {
    display: flex;
    flex-wrap: wrap;

    .geo-info {
      margin-left: 50px;

      a {
        color: inherit !important;
      }
    }
  }

  &.checked {
    background-color: @color-primary;
    .address-icon-section {
      svg {
        .fill-svg(#ffffff);
      }
    }
    .address,
    .price-info,
    .address-info,
    .poligon-info {
      color: #ffffff;
    }

    .polygon-filial-alert {
      background: #fff;
      border-color: #fff;
    }

    // На оранжевом фоне выбранного адреса розовая таблетка не читается
    ::v-deep .filial-stop-label {
      color: #ffffff;
      border-color: #ffffff;
    }

    .polygon-error {
      color: black;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  .address-icon-section {
    margin-right: 23px;

    svg {
      width: 25px;
      height: 19px;
    }

    // уже 1300px иконки нет - её 48px отданы тексту адреса
    @media (max-width: 1299px) {
      display: none;
    }
  }

  .address-info-section {
    flex: 1;

    .address {
      display: block;
      font-size: 18px;
      line-height: 1.2;
      margin-bottom: 6px;
      .media-xl({
        font-size: 24px;
      });
    }

    .price-info {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .buttons-section {
    .action-button {
      height: 50px;
      width: 50px;

      svg {
        width: 18px;
        height: 18px;
      }
    }

    .button-checked {
      background-color: @color-success;

      svg {
        .fill-svg(#fff);
      }
    }

    .button-edit {
      background-color: #d4ddeb;

      svg {
        .fill-svg(@color-secondary);
      }

      &-white {
        border: 2px solid #fff;
        background-color: @color-primary;
        .fill-svg(#fff);
      }
    }

    .button-delete {
      background-color: #d4ddeb !important;

      svg {
        .fill-svg(@color-secondary);
      }

      ::v-deep {
        .v-btn__content {
          text-align: center;
        }
      }

      &:hover {
        svg {
          .fill-svg(@color-pink);
        }
      }
    }
  }
}
</style>
